<template>
    
    <div>
        <b-row>
            <b-col sm="12">
            <b-form-group>
                <b-form-input type="text" id="name" v-model="documentFilter" placeholder="Filtro"></b-form-input>
            </b-form-group>
            </b-col>
        </b-row>
        <div class="Scroll">

            <b-list-group  >
                <b-list-group-item href="#" class="flex-column align-items-start" v-for="item in filteredDocuments" :key="item.id">

                <div class="message" @click="openModal(item)">
                    <div class="pt-3 mr-3 float-left">
                    <div class="avatar">
                        <img :src="item.icon != null ? item.icon : 'img/document.png'" class="img-avatar" alt="admin@bootstrapmaster.com">
                        <span class="avatar-status bg-success"></span>
                    </div>
                    </div>
                    <div>
                    <small class="text-muted">{{ item.publishedIn }}</small>
                    <div>
                        <small class="float-right mt-1 text-primary font-weight-bold" style="font-size: 14px">{{ item.publhserName }}</small>
                    </div>
                    
                    </div>
                    <div class="text-truncate font-weight-bold" style="font-size: 16px" >{{ item.title }}</div>
                    <div class="small text-muted text-truncate">{{ item.description }}</div>
                    
                    <div class="small text-muted text-truncate">{{ item.firstFileUrl }}
                    <br><small class="text-muted mr-3"><i class="icon-user"></i>&nbsp;&nbsp;{{ item.publisherName }}</small>
                    </div>
                    
                </div>

                </b-list-group-item>
            </b-list-group>

        </div>

        <b-modal :title="selectedDocument.title" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedDocument">
            <div class="ratio ratio-16x9">
                <iframe
                :src="this.selectedDocument.firstFileUrl"
                :title="this.selectedDocument.title"
                allowfullscreen
                width="100%"
                height="600px"
                ></iframe>
            </div>
        </b-modal>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'componentPhone',
    data: function() {
        return {
            documentFilter: '',
            
            documentModal: false,
            selectedDocument: null,
            documents: [
                /*
                {
                  id: 1,
                  url: 'teste',
                  name: 'Teste 234234 23',
                  date: '25/04/2022',
                  icon: 'img/document.png',
                  width: "100%",
                  height: "600px"
                },
                {
                  id: 2,
                  url: 'teste',
                  name: 'Teste 234234 ',
                  date: '25/04/2022',
                  icon: 'img/document.png',
                  width: "100%",
                  height: "600px"
                },
                {
                  id: 3,
                  url: 'teste',
                  name: 'Teste65 56 765 ',
                  date: '25/04/2022',
                  icon: 'img/document.png',
                  width: "100%",
                  height: "600px"
                }*/
                
            ]
        }
    },
    computed: {
        filteredDocuments() {
            try {
                return this.documents.filter(item => {
                return this.documentFilter == '' || item.name.toLowerCase().indexOf(this.documentFilter.toLowerCase()) > -1
                }).sort((a, b) => a.title.localeCompare(b.title))
            }
            catch(e) {
                return this.documents;
            }
        }
    },
    methods: {
        openModal(item) {
            this.selectedDocument = item;
            this.documentModal=true;

           

        },
        async refreshData() {
            var s = this;
            
            var currentUserURL = currentUserURL = "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid;
            
            if(currentUserURL.indexOf("undefined") >= 0)
                currentUserURL = ''
                
            await axios.get(
                this.$store.state.ws_url + "/portal/document?companyId=" + this.$store.state.config.companyId + currentUserURL
            ).then(function(resp) {
                s.documents = resp.data.obj;
            }).catch(function(error) {
                console.log(error)
            })  
          
        },
    },
    mounted: function(){
        this.refreshData();
    }
}

</script>


<style scoped>
   #wrapper {
        display:flex;    
        width:100%;
        align-content: streach;
        justify-content: space-between;
    }    

    #wrapper div {
        /* height:100px; */
    }

    .staticMain {
        flex: 0 0 800px;
    }
    .staticLeft {
        flex: 0 0 330px;
    }

    .staticDiv {
        flex: 0 0 10px;
    }

    .growMax {
        flex-grow: 1;
    }
    .Scroll {
        max-height: 400px;
        overflow-y: scroll;
    }
</style>
